import { createStore } from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import game from './game/index.js';
import quiz from './quiz/index.js';

export default createStore({
    modules: {
        game: game,
        quiz: quiz
    },
    state() {
        return {

        }
    },
    getters: {

    },
    mutations: {

    },
    actions: {

    },
    plugins: [createPersistedState({
        storage: window.sessionStorage,
    })]
});
